<div class="card">
  <app-header titulo="Cadastro de usuário" descricao=""></app-header>

  <div class="w-50">
    <div class="field">
      <label for="nome">Nome:</label>
      <input
        id="nome"
        pInputText
        type="text"
        [(ngModel)]="usuario.nomeUsuario"
        class="w-full"
        required
        autofocus
      />
      <small class="p-error" *ngIf="usuarioEnviado && !usuario.nomeUsuario"
      >Nome é obrigatório.</small
      >
    </div>
    <div class="field">
      <label for="nome">E-mail:</label>
      <input
        id="nome"
        pInputText
        type="text"
        [(ngModel)]="usuario.email"
        class="w-full"
        required
        autofocus
      />
      <small class="p-error" *ngIf="usuarioEnviado && !usuario.email"
      >E-mail é obrigatório.</small
      >
    </div>
    <div class="field">
      <label for="nome">Usuário ERP:</label>
      <input
        id="nome"
        pInputText
        type="text"
        [(ngModel)]="usuario.cdUsuarioErp"
        class="w-full"
        required
        autofocus
      />
      <small class="p-error" *ngIf="usuarioEnviado && !usuario.cdUsuarioErp"
      >Usuário ERP é obrigatório.</small
      >
    </div>
    <div class="field">
      <label for="base">Perfil:</label>
      <!-- <p-dropdown [style]="{'width':'100%'}" appendTo="body" [options]="perfis" optionValue="id" optionLabel="nomePerfil" [(ngModel)]="usuario.perfilId" dataKey="id" inputId="id" placeholder="Selecione um perfil" emptyMessage="Nenhum perfil disponivel"></p-dropdown> -->
      <p-multiSelect
        [options]="perfis"
        appendTo="body"
        [(ngModel)]="perfisSelecionados"
        placeholder="Selecione um Perfil"
        optionValue="id"
        optionLabel="nomePerfil"
        display="chip"
        styleClass="w-full md:w-80"
        (onChange)="carregaFuncoes()"
      />
      <small
        class="p-error"
        *ngIf="usuarioEnviado && perfisSelecionados.length === 0"
      >Perfil é obrigatório.</small
      >
    </div>
    <div class="field">

      <label for="funcoes">Funções:</label>
      <p-listbox id="funcoes" dataKey="id" [options]="funcoes" optionLabel="nome" [checkbox]="true" [multiple]="true" [(ngModel)]="funcoesSelecionadas" emptyMessage="Nenhuma função disponível">
        <ng-template pTemplate="item" let-funcao>
           {{ funcao.nomeModulo }} - {{ funcao.nome }}
        </ng-template>
      </p-listbox>

    </div>
    <div class="field">
      <label for="base">Instâncias - Painel de Insumos:</label>
      <!-- <p-dropdown [style]="{'width':'100%'}" appendTo="body" [options]="perfis" optionValue="id" optionLabel="nomePerfil" [(ngModel)]="usuario.perfilId" dataKey="id" inputId="id" placeholder="Selecione um perfil" emptyMessage="Nenhum perfil disponivel"></p-dropdown> -->
      <p-multiSelect
        [options]="empresasPainelInsumo"
        appendTo="body"
        [(ngModel)]="empresasPainelInsumoSelecionados"
        placeholder="Selecione uma instância"
        optionValue="id"
        optionLabel="centroErp"
        styleClass="w-full"
        selectedItemsLabel="{0} instâncias selecionadas"
        [selectionLimit]="10"
        display="chip"
        [maxSelectedLabels]="10"
      >
        <ng-template let-instancia pTemplate="item">
          <div>Instância: {{ instancia.instancia }} - Centro: {{ instancia.centroErp }}</div>
        </ng-template>
      </p-multiSelect>
      <small
        class="p-error"
        *ngIf="usuarioEnviado && perfisSelecionados.length === 0"
      >Perfil é obrigatório.</small
      >
    </div>

  </div>
  <div class="field col-2 pt-4">
    <button
      pButton
      [label]="usuario.id ? 'Atualizar' : 'Salvar'"
      icon="pi pi-check"
      class="p-button-success"
      (click)="salvar()"
      [loading]="loading"
    ></button>
  </div>

</div>
